/**
 * Resolves --padding-sm from an element's context to pixels (for spaceBetween).
 * @param {Element} el - Element to read computed style from (for var() context).
 * @returns {number} Length in pixels.
 */
function getComputedGapPx(el) {
  const value = getComputedStyle(el).getPropertyValue("--padding-sm")?.trim() || "16px";
  if (value.endsWith("px")) return parseInt(value, 10) || 16;
  if (value.endsWith("rem")) {
    const rem = parseFloat(value) || 1;
    const rootFontSize = parseFloat(getComputedStyle(document.documentElement).fontSize) || 16;
    return Math.round(rem * rootFontSize);
  }
  return parseInt(value, 10) || 16;
}

/**
 * Inits Swiper on resource list carousel elements (e.g. product recommendations mobile).
 * Call initResourceListSwipers(container) after dynamically injecting HTML that contains
 * .resource-list__carousel--swiper (e.g. from product-recommendations).
 *
 * @param {Document|Element} [root] - Root to search; defaults to document.
 */
function initResourceListSwipers(root = document) {
  const scope = root instanceof Document ? root.documentElement : root;
  const els = scope.querySelectorAll?.("[data-resource-list-swiper]:not([data-swiper-initialized])");
  if (!els?.length) return;

  const Swiper = window.Swiper;
  if (!Swiper) return;

  els.forEach((el) => {
    const spaceBetween = el.dataset.spaceBetween
      ? Number(el.dataset.spaceBetween)
      : getComputedGapPx(el);
    const slidesPerViewRaw = el.dataset.slidesPerView;
    const slidesPerView = slidesPerViewRaw
      ? (Number(slidesPerViewRaw) || "auto")
      : "auto";
    const swiper = new Swiper(el, {
      slidesPerView,
      spaceBetween,
      grabCursor: true,
      resistanceRatio: 0.85,
      watchOverflow: true,
      loop: false,
    });
    el.dataset.swiperInitialized = "true";
    el._resourceListSwiper = swiper;
  });
}

if (typeof window !== "undefined") {
  window.initResourceListSwipers = initResourceListSwipers;
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => initResourceListSwipers(document));
} else {
  initResourceListSwipers(document);
}
